export const animation = () => {
	const selector = ".fade-up, .fade-left, .fade-right";

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-visible");
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.1 },
	);

	document.querySelectorAll(selector).forEach((el) => observer.observe(el));
};
